<template>
  <div class="egg-container">
    <div class="coupon-instruction" id="coupon-instruction" v-if="!isClicked">
      <span class="title">Cepetan!</span><br>
      <span class="highlight title-2">Ketuk & Pecahkan Telur!</span><br>
      <span class="title-3">Ambil KUPON JAJAN nya!</span><br>
      <br>
    </div>
    <div class="nest-area">
      <div id="eggWrap" class="egg-wrap">
        <div id="eggImg" class="egg-img"></div>
        <div id="eggTop" class="egg-top"></div>
        <div id="eggBottom" class="egg-bottom"></div>
      </div>
    </div>
    <div class="countdown" id="countdown">
      <span class="countdown-text">Hangus dalam </span>
      <span class="countdown-timer" id="countdownTimer">00:30</span>
    </div>
  </div>
  <div id="popupText" class="popup-text">Pecah Telurnya!</div>
  <div class="modal-egg" id="modal-egg">
    <div class="kupon-gosok-instructions" v-if="isCracked">
      <span id="title">SELAMAT,</span><br>
      <span id="title-2">KAMU DAPAT KUPON JAJAN!</span><br>
      <span id="title-3">KLAIM SEKARANG!</span>
    </div>
    <div class="card" role="dialog" aria-modal="true" aria-labelledby="ttl">
      <div id="codeBox" class="codebox" aria-live="polite" v-if="!isRedirect">{{ code }}</div>
      <div id="codeBox" class="codebox text" aria-live="polite" v-if="isRedirect">Menghubungkan Anda ke Telkomsel…</div>
      <div class="actions">
        <button type="button" class="btn btn-neon" id="redemptionWebOptIn" @click="submitCode(code)">SALIN &amp; KLAIM DI
          SINI
          <span aria-hidden="true">&rsaquo;</span></button>
      </div>
    </div>
  </div>
  <div class="modal-time" id="modal-time">
    <div class="card" role="dialog" aria-modal="true" aria-labelledby="ttl">
      <div class="timeout-text">
        <span class="title-2">Yaah, Waktumu habis</span><br>
        <span class="title-3">Mau coba lagi?</span><br>
      </div>
      <button type="button" class="btn-retry btn" id="redemptionWebOptIn" @click="retry">
        COBA LAGI
      </button>
    </div>
  </div>
  <div id="confetti" class="confetti" aria-hidden="true"></div>
  <div class="preload-images">
    <img :src="baseUrl + 'img/egg-1.png'" alt="">
    <img :src="baseUrl + 'img/egg-2.png'" alt="">
    <img :src="baseUrl + 'img/egg-3.png'" alt="">
    <img :src="baseUrl + 'img/egg-4.png'" alt="">
    <img :src="baseUrl + 'img/egg-5.png'" alt="">
    <img :src="baseUrl + 'img/egg-6.png'" alt="">
    <img :src="baseUrl + 'img/egg-bg.jpg'" alt="">
    <img :src="baseUrl + 'img/ticket.webp'" alt="">
  </div>
</template>

<script>
import { global } from "../utils";
import { event } from "vue-gtag";
import { Api } from "../services";
import config from '../utils/config';
import { useHead } from '@vueuse/head'

export default {
  name: "LuckeEgg",
  setup() {
    const images = [
      'img/egg-1.png',
      'img/egg-2.png',
      'img/egg-3.png',
      'img/egg-4.png',
      'img/egg-5.png',
      'img/egg-6.png',
      'img/egg-bg.jpg'
    ];

    const css = [
      'css/scratch.css',
      'css/egg.css',
      'css/modal.css',
    ];

    const preloadLinks = images.map(src => ({
      rel: 'preload',
      as: 'image',
      href: `${process.env.BASE_URL}${src}`,
      fetchpriority: 'high'
    }))

    const cssLink = css.flatMap(src => {
      const url = `${process.env.BASE_URL}${src}`;
      return [
        {
          rel: 'preload',
          href: url,
          as: 'style'
        },
        {
          rel: 'stylesheet',
          href: url
        }
      ];
    });

    useHead({
      link: [
        ...preloadLinks,
        ...cssLink
      ]
    })
  },
  data() {
    return {
      totalCracks: 5,
      clicks: 0,
      isRedirect: false,
      code: "??????",
      isClicked: false,
      isTimeRunOut: false,
      baseUrl: process.env.BASE_URL,
      isCracked: false
    };
  },
  mounted() {
    this.code = global.generateCodeKuponJajan();
    this.initEgg();
    this.countdown();
  },
  methods: {
    retry() {
      this.sendGtag(5);
      window.location.reload();
    },
    vibrate(t) {
      if ("vibrate" in navigator) {
        if (t == 1) {
          navigator.vibrate([60]);
        } else {
          navigator.vibrate([200, 20, 750]);
        }
      } else {
        console.log("Vibration API not supported on this device/browser");
      }
    },
    getImg(name) {
      return require(`@/assets/${name}.png`);
    },
    updateEggImage() {
      const eggImg = document.getElementById("eggImg");

      let index = Math.min(this.clicks + 1, this.totalCracks);
      eggImg.className = "egg-img egg-img-" + index;
    },
    initEgg() {
      const eggWrap = document.getElementById("eggWrap");
      const countdown = document.getElementById("countdown");

      let wiggleSpeed = 1.2;

      eggWrap.classList.add("egg-wiggle");
      eggWrap.style.setProperty("--wiggle-speed", wiggleSpeed + "s");

      eggWrap.addEventListener("click", () => {

        if (this.isTimeRunOut) {
          this.sendGtag(4);
          return;
        }

        if (this.clicks == 0) {
          this.sendGtag(0);
        }

        this.clicks++;
        this.vibrate(1);
        wiggleSpeed = Math.max(0.25, wiggleSpeed - 0.2);
        eggWrap.style.setProperty("--wiggle-speed", wiggleSpeed + "s");

        let power = this.clicks * 1.2;
        eggWrap.style.transform = `rotate(${power}deg)`;
        setTimeout(() => (eggWrap.style.transform = `rotate(${-power}deg)`), wiggleSpeed * 500);
        setTimeout(() => (eggWrap.style.transform = `rotate(0deg)`), wiggleSpeed * 900);

        if (this.clicks <= this.totalCracks) {
          this.updateEggImage();
        }

        if (this.clicks === this.totalCracks) {
          eggWrap.style.pointerEvents = "none";
          countdown.style.display = "none"
          clearInterval(window.countdownTimer);
          setTimeout(() => {
            this.hatch();
            this.isCracked = true;
          }, 250);
        }
      });
    },
    countdown() {
      const self = this;
      window.countdownTimer = null;
      window.timeLeft = config.timer_egg;
      const timerElement = document.getElementById('countdownTimer');
      window.countdownTimer = setInterval(function () {
        const minutes = Math.floor(window.timeLeft / 60);
        const seconds = window.timeLeft % 60;

        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        timerElement.textContent = formattedTime;

        if (window.timeLeft <= 60) {
          timerElement.style.color = '#FFF';
          timerElement.style.fontWeight = 'bold';
        }

        if (window.timeLeft <= 0) {
          clearInterval(window.countdownTimer);
          timerElement.textContent = ' ';
          timerElement.style.color = '#FFDE59';
          timerElement.style.fontWeight = 'bold';

          const countdownTextElement = document.querySelector('.countdown-text');
          if (countdownTextElement) {
            countdownTextElement.textContent = '';
          }
          self.isTimeRunOut = true
          self.timeout()
          return;
        }
        window.timeLeft--;
      }, 1000);
    },
    timeout() {
      this.sendGtag(4);
      const instruction = document.getElementById("coupon-instruction");
      const modal = document.getElementById("modal-time");

      instruction.classList.add("hide");
      modal.classList.add("show");
    },
    hatch() {
      const self = this;
      const eggImg = document.getElementById("eggImg");
      const eggTop = document.getElementById("eggTop");
      const eggBottom = document.getElementById("eggBottom");
      const popup = document.getElementById("popupText");
      const modal = document.getElementById("modal-egg");
      const eggWrap = document.getElementById("eggWrap");
      const instruction = document.getElementById("coupon-instruction");

      this.sendGtag(1);

      this.vibrate(2);

      instruction.classList.add("hide");

      eggWrap.classList.remove("egg-wiggle");
      eggWrap.style.transform = "none";

      eggImg.style.opacity = 0;

      eggTop.style.opacity = 1;
      eggBottom.style.opacity = 1;

      eggTop.style.transform = "translateY(-60px)";
      eggBottom.style.transform = "translateY(60px)";

      popup.classList.add("show");

      setTimeout(() => {
        modal.classList.add("show");
        self.confetti();
      },
        500
      );
    },

    confetti() {
      const n = 80;
      const container = document.getElementById("confetti");
      const colors = [
        "#ff1e56",
        "#ffd319",
        "#00d084",
        "#18a0fb",
        "#7c3aed",
        "#10b981",
      ];
      const vw = window.innerWidth;
      for (let i = 0; i < n; i++) {
        const p = document.createElement("div");
        p.className = "piece";
        p.style.left = Math.random() * vw + "px";
        p.style.background = colors[Math.floor(Math.random() * colors.length)];
        const dur = 1.2 + Math.random() * 1.2;
        const delay = Math.random() * 0.2;
        p.style.animationDuration = `${dur}s`;
        p.style.animationDelay = `${delay}s`;
        container.appendChild(p);
        setTimeout(() => p.remove(), (dur + delay) * 1000 + 80);
      }
    },
    sendGtag(type) {
      if (type == 0) event("Pecah Telur - KT", {});
      else if (type == 1) event("Success - Pecah Telur - KT", {});
      else if (type == 2) event("Success - Call WebOptIn - KT", {});
      else if (type == 3) event("Failed - Send Kode to API - KT", {});
      else if (type == 4) event("Pecah Telur - Waktu Habis - KT", {});
      else if (type == 5) event("Pecah Telur - Retry - KT", {});
    },
    async submitCode(code) {
      this.isRedirect = true;

      try {
        await navigator.clipboard.writeText(code);
      } catch (err) {
        console.error("Copy failed:", err);
      }

      Api.submitCode(code)
        .then((data) => {
          if (data.data.success == 1) this.sendGtag(2);
          else this.sendGtag(3);
          if (this.$route.path === '/pecahkan-tukar') {
            global.portalRedirect(config.kjw_url, code, 1500)
          } else {
            global.portalRedirect(config.idw_url, code, 1500)
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
